// utils/searchSuggestions.js
import { toLower, trim } from "lodash";

export const getSuggestedSearches = (products, searchInput) => {
  if (!products || products.length === 0 || !searchInput) return [];

  const normalizedSearch = toLower(trim(searchInput));
  const normalizedInputLength = normalizedSearch.length;

  return products
    .filter((product) => {
      const normalizedName = toLower(product.name);
      const normalizedSku = toLower(product.sku);
      return (
        normalizedName.includes(normalizedSearch) ||
        normalizedSku.includes(normalizedSearch)
      );
    })
    .map((product) => {
      const normalizedName = toLower(product.name);
      const normalizedSku = toLower(product.sku);

      // Determine the best match (name or sku) by finding the longest continuation
      const nameMatchStart = normalizedName.indexOf(normalizedSearch);
      const skuMatchStart = normalizedSku.indexOf(normalizedSearch);

      let label, hrefField;
      if (nameMatchStart !== -1 && skuMatchStart !== -1) {
        // If both match, prefer the one with the shortest remaining text
        const nameRemaining = normalizedName.slice(
          nameMatchStart + normalizedInputLength
        );
        const skuRemaining = normalizedSku.slice(
          skuMatchStart + normalizedInputLength
        );
        [label, hrefField] =
          nameRemaining.length < skuRemaining.length
            ? [
                product.name.slice(0, nameMatchStart + normalizedInputLength) +
                  nameRemaining,
                product.name,
              ]
            : [
                product.sku.slice(0, skuMatchStart + normalizedInputLength) +
                  skuRemaining,
                product.sku,
              ];
      } else if (nameMatchStart !== -1) {
        label =
          product.name.slice(0, nameMatchStart + normalizedInputLength) +
          normalizedName.slice(nameMatchStart + normalizedInputLength);
        hrefField = product.name;
      } else if (skuMatchStart !== -1) {
        label =
          product.sku.slice(0, skuMatchStart + normalizedInputLength) +
          normalizedSku.slice(skuMatchStart + normalizedInputLength);
        hrefField = product.sku;
      }

      // Bold the matched portion (searchInput) in the label
      const matchStart = toLower(label).indexOf(normalizedSearch);
      if (matchStart !== -1) {
        const matchedPortion = label.slice(
          matchStart,
          matchStart + normalizedInputLength
        );
        const remainingPortion = label.slice(
          matchStart + normalizedInputLength
        );
        label = (
          <>
            {label.slice(0, matchStart)}
            <strong>{matchedPortion}</strong>
            {remainingPortion}
          </>
        );
      }

      return {
        label: label || searchInput, // Fallback to searchInput if no match
        href: `/product/${encodeURIComponent(hrefField || searchInput)}`,
      };
    })
    .slice(0, 5) // Limit to 5 suggestions
    .sort((a, b) => a.label.toString().localeCompare(b.label.toString())); // Sort alphabetically, handling JSX
};
